import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication-service';
import { ContextService } from './context-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService, private router: Router,
    private contextService: ContextService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const excludedUrls = ['login', 'oauth'];
        const isExcluded = excludedUrls.some(endpoint => req.url.includes(endpoint));
        if (error.status === 401 && this.contextService.loggedIn && !isExcluded) {
          this.authService.logoff();
        }
        return throwError(() => error);
      })
    );
  }
}
